import React from "react"
import {Box, Button, Dialog, DialogContent, DialogTitle, Typography} from "@mui/material";
import {CustomDropzoneUploadDocument} from "../../../../brand/customDropzoneUploadDocument";
import {Trans} from "@lingui/macro";
import {ErrorDialog, withUseFormHook} from "@sinossi/mates-react-library";
import {UseFormReturn} from "react-hook-form";
import * as Yup from "yup";

interface UploadPhotoModalState {
    errorDialog: {
        open: boolean
        title: string
        message: string
    }
}

interface UploadPhotoModalProps extends UseFormReturn{
    open: boolean
    onClose: () => void
    callbackUploadPhoto: (formData: FormData) => void
}

const UploadPhotoModalSchema = Yup.object().shape({
})

class UploadPhotoModal extends React.Component<UploadPhotoModalProps, UploadPhotoModalState>{

    private photoData: File | null = null

    private fileError: boolean = false

    constructor(props: any) {
        super(props)
        this.state = {
            errorDialog: {
                open: false,
                title: "",
                message: "",
            },
        }
    }

    private uploadPhoto = (photo: File) => {
        if (photo){
            this.photoData = photo
        }
    }

    private submitPhoto = () => {
        const request = {
            documentType: "PHOTO",
            documentNumber: ""
        }

        const formData: FormData = new FormData()
        formData.append(
            "data",
            new Blob([ JSON.stringify(request) ], { type: "application/json" }),
            ""
        )
        if(this.photoData && (this.photoData.name.includes(".jpg") || this.photoData.name.includes(".png") || this.photoData.name.includes(".JPG") || this.photoData.name.includes(".PNG"))) {
            this.fileError = false
            formData.append("file", this.photoData)
            this.props.callbackUploadPhoto(formData as FormData)
        } else {
            this.fileError = true
        }
    }

    private onErrorDialogClose = (): void => {
        this.setState(() => ({
            errorDialog: {
                open: false,
                title: "",
                message: "",
                okText: "",
            }
        }))
    }

    render () {
        return(
                <Dialog
                    open={true}
                    onClose={() => this.props.onClose()}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle>
                        <Trans id={"af-upload_photo-modal-title"}>
                            Upload foto
                        </Trans>
                    </DialogTitle>
                    <form onSubmit={this.props.handleSubmit(this.submitPhoto)}>
                        <DialogContent sx={{
                            p:2
                        }}>
                            <CustomDropzoneUploadDocument callback={this.uploadPhoto} text={"custom-dropzone-upload-document.upload-photo"}/>
                        </DialogContent>
                        <Box display="flex" justifyContent="center" sx={{mt: 2, mb: 3}}>
                            <Button variant="contained"
                                    type="submit"
                                    disableElevation
                                    sx={{
                                        textTransform: 'none',
                                        backgroundColor: 'secondary.main',
                                        color: 'white',
                                        paddingX: 5,
                                        height: 28,
                                    }}
                            >
                                <Trans id="documents-table.upload-button">
                                    <Typography>
                                        Carica
                                    </Typography>
                                </Trans>
                            </Button>
                        </Box>
                    </form>
                    <ErrorDialog
                        ok={this.onErrorDialogClose}
                        {...this.state.errorDialog}/>
                </Dialog>
            )
    }
}

export default withUseFormHook<{}>(
    UploadPhotoModal,
    UploadPhotoModalSchema
)
